import {CanActivateFn, Router} from '@angular/router';
import { inject } from '@angular/core';
import {fetchAuthSession} from "aws-amplify/auth";
import { getCookie } from 'typescript-cookie';


export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);

  return fetchAuthSession()
    .then((session) => {

      let token: string | undefined = session?.tokens?.idToken?.toString() ; 
      
      if (!token) {
        token = getCookie('guest_token') ;
      }

      if (token) {
        return true ;
      } else {
        const url = router.parseUrl('/signin');
        url.queryParams = {
          returnUrl: state.url
        }
        return url ;
      }
    }) ;
};